import { Link } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import PageSeo from "@/components/feature/PageSeo";

export default function NotFound() {
  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <PageSeo
        title="页面不存在 | 爆料官网"
        description="你访问的页面不存在或已下线，可以返回首页查看今日发布的头条新闻与最新动态。"
        keywords="爆料官网,页面不存在,今日发布"
        canonicalPath="/"
      />
      <SiteHeader />
      <main className="mx-auto flex w-full max-w-[1280px] flex-1 flex-col items-center justify-center px-4 py-24 text-center md:px-6">
        <p className="font-heading text-6xl font-bold text-background-300 md:text-8xl">404</p>
        <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
          这个页面已下线
        </h1>
        <p className="mt-3 max-w-md font-body text-sm leading-7 text-foreground-600">
          你访问的内容可能已被更正、合并或调整了地址。不妨回到首页，看看今天的头条与最新动态。
        </p>
        <div className="mt-7 flex flex-wrap justify-center gap-3">
          <Link
            to="/"
            className="whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 font-label text-sm text-background-50 transition-colors hover:bg-primary-600 dark:text-foreground-950"
          >
            返回首页
          </Link>
          <Link
            to="/channel/all"
            className="whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 font-label text-sm text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600"
          >
            浏览全部爆料
          </Link>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}